module.exports = global["rpDiffusion"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/index.js-exposed
// module id = 168
// module chunks = 1